export default __webpack_public_path__ + "static/media/resume.0b6c793b.jpg";